import { Stack, StackProps, styled } from "@mui/material";

type IBannerInfo = {
  $mandatory?: boolean;
  $accentVisible?: boolean;
  $collapsedView?: boolean;
  $isHover?: boolean;
  $isProfile?: boolean;
}

export const BannerInfoContainer = styled(Stack)<StackProps & IBannerInfo>(({ theme, $accentVisible, $collapsedView, $isProfile, $isHover }) => ({
  ...$accentVisible && {
    ":hover": {
      background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
      // background: theme.customColors.backgroundSecondaryHover, //TODO ripristinare
      ...!$isProfile && {
        cursor: "pointer"
      }
    }
  },
  alignItems: $collapsedView ? "center" : undefined,
  background: $isHover && !$collapsedView ? `rgba(${theme.customColors.backgroundSecondaryHover})` : "transparent",
  // background: $isHover ? theme.customColors.backgroundSecondaryHover : "transparent", //TODO ripristinare
  borderRadius: "0.5rem",
  flexDirection: $collapsedView ? "row" : undefined,
  justifyContent: $collapsedView ? "space-between" : undefined,
  margin: "0 0.5rem",
  paddingRight: $collapsedView ? "0.5rem" : undefined,
  width: "100%"
}));

export const TypoContainer = styled(Stack)<StackProps & Pick<IBannerInfo, "$collapsedView">>(({ $collapsedView }) => ({
  alignItems: $collapsedView ? "flex-start" : "center",
  background: "transparent",
  display: "flex",
  flexDirection: $collapsedView ? "column" : "row",
  flexGrow: 1,
  gap: $collapsedView ? "0.25rem" : undefined,
  justifyContent: "space-between"
}));

export const BannerInfo = styled(Stack)<StackProps & IBannerInfo>(({ theme, $mandatory, $collapsedView }) => ({
  "&:before": {
    alignSelf: "stretch",
    background: $mandatory ? theme.customColors.textWarning : theme.customColors.systemSecondary01,
    borderRadius: "0.125rem",
    content: "''",
    marginLeft: "0.5rem",
    marginRight: "1rem",
    position: "relative",
    width: "0.125rem"
  },
  display: "flex",
  flex: $collapsedView ? 1 : undefined,
  flexDirection: "row",
  padding: "0.5rem 0.5rem 0.5rem 0rem"
}));
